import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import './editor.scss';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import indexjson from './edit.json';
import { TbTimelineEventPlus } from "react-icons/tb";

registerBlockType( metadata.name, {
	...metadata,
	attributes: {...indexjson},
	edit: Edit,
	icon: <TbTimelineEventPlus  style={{color:'#6c1bc3',transform:'rotate(90deg)'}} />,
	save,
} );


